module.exports = __webpack_public_path__ + "img/bim.82830da2.svg";